export enum PaysafeTestHooks {
  Form = 'credit-card-form',
  NameOnCard = 'credit-card-name-iframe',
  CardNumber = 'credit-card-code-iframe',
  ExpiryDate = 'credit-card-expiry-date-iframe',
  CVV = 'credit-card-cvv-iframe',
}
